import { Text } from '@vimeo/bokeh';
import { IBaseDomElementProps } from '@vimeo/core/types/dom';

import { createDomName } from '../../../../utils/dom/identifying';
import { BokehTooltip } from '../../../bokeh';

interface IQuestionItemAuthorProps extends IBaseDomElementProps {
  name: string;
}

/**
 * Question title, expected to be single line with ellipses.
 * Covered with tooltip to show full name.
 */
export function QuestionItemAuthor({
  className = createDomName('question-author-name'),
  name,
}: IQuestionItemAuthorProps) {
  return (
    <BokehTooltip placement={'bottom'} label={name} shouldWrapChildren={false}>
      <Text
        className={className}
        variant={'heading-xs'}
        textOverflow={'ellipsis'}
        whiteSpace={'nowrap'}
        overflow={'hidden'}
        maxWidth={'100%'}
      >
        {name}
      </Text>
    </BokehTooltip>
  );
}
